export const PUBLIC_CHECKOUT_PATH_REGEX = /^\/events\/([^/]+)(?:\/success)?$/

export const getPublicCheckoutEventId = (pathname: string) => {
  return pathname.match(PUBLIC_CHECKOUT_PATH_REGEX)?.[1] ?? null
}

export const isPublicCheckoutPath = (pathname: string) => {
  return PUBLIC_CHECKOUT_PATH_REGEX.test(pathname)
}
